<div class="section task-options">
  <div class="row">
    <div class="col-xl-12" *ngIf="completable">
      <button (click)="onComplete()" class="btn btn-lg btn-block mb-3 btn-outline-primary">
        {{ completeButtonText }}
      </button>
    </div>
    <div class="col-xl-12">
      <button (click)="onDecline()" class="btn btn-lg btn-outline-primary btn-block mb-3">
        {{ declineButtonText }}
      </button>
    </div>
    <div class="col-xl-12" *ngIf="hasSecondComplete">
      <button
        (click)="onSecondButtonComplete()"
        class="btn btn-lg btn-outline-primary btn-block mb-3"
      >
        {{ secondCompleteButtonText }}
      </button>
    </div>
  </div>
</div>
